import React from 'react';
import { motion } from 'framer-motion';

/**
 * Reusable Refresh Button Component
 * Provides consistent refresh functionality across all dashboard pages
 */
const RefreshButton = ({ 
  onRefresh, 
  isRefreshing = false, 
  tooltip = "Refresh Data",
  variant = "default", // "default" | "compact"
  className = ""
}) => {
  const baseClasses = variant === "compact" 
    ? "p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-200 active:scale-95"
    : "flex items-center gap-2 px-3 py-2 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-xl transition-all duration-200 active:scale-95 shadow-sm";

  return (
    <motion.button
      onClick={onRefresh}
      disabled={isRefreshing}
      className={`${baseClasses} ${isRefreshing ? 'opacity-75 cursor-not-allowed' : ''} ${className}`}
      title={tooltip}
      whileHover={{ scale: isRefreshing ? 1 : 1.02 }}
      whileTap={{ scale: isRefreshing ? 1 : 0.98 }}
    >
      <svg 
        className={`w-4 h-4 text-gray-600 dark:text-gray-400 ${isRefreshing ? 'animate-spin' : ''}`} 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24" 
        strokeWidth={2}
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11.418 2a8.001 8.001 0 01-15.356 2m0 0H15M4 18v-5h.582m15.356 2A8.001 8.001 0 004.582 15m0 0H9m11.418 2a8.001 8.001 0 01-15.356 2m0 0H15" 
        />
      </svg>
      {variant === "default" && (
        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {isRefreshing ? 'Refreshing...' : 'Refresh'}
        </span>
      )}
    </motion.button>
  );
};

export default RefreshButton;

